import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import { Button, Label, TextArea } from "abs-ui-components";

import "./B8EmissionfactorsAnnex1.scss";

import { AUTOSAVE_SUCCESS_MESSAGE, commonFormFields } from "../../Constants";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService.js";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave.js";

const B8EmissionfactorsAnnex1 = forwardRef(({ b8EmissionFactorsData,vesselMstId, refetchMonitoringData }, ref) => {
    
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (b8EmissionFactorsData) {
            const current = getValues();
            reset({ ...current, b8: b8EmissionFactorsData });
        }
    }, [b8EmissionFactorsData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });
    const handleSave = async (isAuto = false) => {
        const formValues = getValues("b8");
        const payload = {
            ...commonFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const b8EmissionFactors = await callApi({
                method: "POST",
                url: API_ROUTES.B8(vesselMstId),
                data: payload,
            });
            if (b8EmissionFactors?.isSuccess) {
                emitToasterMsg("success", "Table B.8", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, b8: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table B.8", b8EmissionFactors?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table B.8", error?.errorMessage);
        }
    };

    return (
        <div className="b8-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Determination of emission factors</h6>
                </MDBCol>
            </MDBRow>
            {commonFormFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`b8.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`b8_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}
            <div className="text-center">
                <Button id="b8_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isDirty}
                >Save</Button>
            </div>
        </div>
    );
});


export default B8EmissionfactorsAnnex1;